exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#444",
	"menuActiveText": "#272727",
	"subMenuActiveText": "#004EA8",
	"menuBg": "#FCFDFF",
	"menuHover": "#E8F2FF",
	"menuActiveBg": "#E8F2FF",
	"subMenuBg": "#fff",
	"subMenuHover": "#CBDBF3",
	"subMenuActiveBg": "#CBDBF3",
	"sideBarWidth": "1.09375rem",
	"appMainBg": "#F2F4F8"
};